"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledType = void 0;
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _index.default;
  }
});
Object.defineProperty(exports, "sizes", {
  enumerable: true,
  get: function () {
    return _index.sizes;
  }
});
var _index = _interopRequireWildcard(require("./index.styled"));
const StyledType = exports.StyledType = _index.StyledType;